var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50015 10.5L12.6412 7.08003C12.77 6.9499 12.8423 6.77417 12.8423 6.59103C12.8423 6.4079 12.77 6.23217 12.6412 6.10203C12.5779 6.03778 12.5025 5.98676 12.4193 5.95193C12.3361 5.91711 12.2468 5.89917 12.1567 5.89917C12.0665 5.89917 11.9772 5.91711 11.894 5.95193C11.8108 5.98676 11.7354 6.03778 11.6722 6.10203L7.84215 10.01C7.71348 10.1405 7.64134 10.3163 7.64134 10.4995C7.64134 10.6828 7.71348 10.8586 7.84215 10.989L11.6722 14.897C11.7354 14.9613 11.8108 15.0123 11.894 15.0471C11.9772 15.082 12.0665 15.0999 12.1567 15.0999C12.2468 15.0999 12.3361 15.082 12.4193 15.0471C12.5025 15.0123 12.5779 14.9613 12.6412 14.897C12.77 14.7669 12.8423 14.5912 12.8423 14.408C12.8423 14.2249 12.77 14.0492 12.6412 13.919L9.50015 10.5Z",
    fill: "#534DE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.a8529dc93d14db88491947ae1e6e990e.svg";
export { ForwardRef as ReactComponent };